module.exports = __webpack_public_path__ + "files/cfd77a046766ed658704e68f824f9d1c.png";